import { gql } from '@apollo/client';
import { ContactListFragment } from '../fragments/ContactListFragment';
/**
 * @const ContactListQuery
 * @since 1.0.0
 */
export const ContactListQuery = gql `
  query ContactListQuery($input: ContactsInput) {
    contacts(input: $input) {
      items {
        ...ContactListFragment
      }
      count
    }
  }

  ${ContactListFragment}
`;
